export const API_URL = process.env.REACT_APP_API_URL || "https://stage-api-test.anemiamuktbharat.info";
//export const ADMIN_API_URL = "http://161.118.166.7/nhsrc/api";
export const ADMIN_API_URL = "https://ambabhiyaan.mohfw.gov.in/nhsrc/api";
// export const ADMIN_API_URL = "http://172.16.1.152:5000/api";
export const ORIGIN = process.env.REACT_APP_ORIGIN || "https://anemiamuktbharat.info";

export const cohorts = [
    {
        label: "Pregnant Women",
        non: "preg_non_anaemic",
        mild: "preg_mild",
        mod: "preg_moderate",
        sev: "preg_severe"
    },
    {
        label: "Children (6-59M)",
        non: "child_6_59m_non_anaemic",
        mild: "child_6_59m_mild",
        mod: "child_6_59m_moderate",
        sev: "child_6_59m_severe"
    },
    {
        label: "Child (5-9Y)",
        non: "child_5_9y_non_anaemic",
        mild: "child_5_9y_mild",
        mod: "child_5_9y_moderate",
        sev: "child_5_9y_severe"
    },
    {
        label: "Adolescents (10-19Y)",
        non: "child_10_19y_non_anaemic",
        mild: "child_10_19y_mild",
        mod: "child_10_19y_moderate",
        sev: "child_10_19y_severe"
    },
    {
        label: "WRA (20-49Y)",
        non: "wra_20_49y_non_anaemic",
        mild: "wra_20_49y_mild",
        mod: "wra_20_49y_moderate",
        sev: "wra_20_49y_severe"
    },
    {
        label: "Lactating Mother",
        non: "lactating_non_anaemic",
        mild: "lactating_mild",
        mod: "lactating_moderate",
        sev: "lactating_severe"
    },
    {
        label: "Men (15-49Y)",
        non: "men_19plus_non_anaemic",
        mild: "men_19plus_mild",
        mod: "men_19plus_moderate",
        sev: "men_19plus_severe"
    },
    {
        label: "Senior Women (49+Y)",
        non: "women_49plus_non_anaemic",
        mild: "women_49plus_mild",
        mod: "women_49plus_moderate",
        sev: "women_49plus_severe"
    }
];
